export default "__VITE_ASSET__Wwr6gq9r__"